import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {VpnService} from '@services/vpn/vpn.service';

@Component({
  selector: 'app-vpn-disconnected',
  imports: [],
  template: `<div class="content-pane">
    <h2>Secure Network Connection Required</h2>
    <p>
      Users must be on a local secure institutional network or connected via a high-security institutional VPN in order
      to access the Private Data Enclave.
    </p>
    <p>Once you're on a secure network, you'll be redirected to the content you were trying to reach.</p>
    <p>
      If you have connected but do not see your private projects, try refreshing this page. Please contact
      <a href="mailto:rde_admin@virginia.edu">our team</a> if the issue persists.
    </p>
  </div>`,
})
export class VpnDisconnectedComponent {
  constructor(
    private readonly vpnService: VpnService,
    private readonly router: Router,
  ) {
    vpnService.isConnected.subscribe(state => {
      if (state) {
        // @ts-expect-error // `targetBrowserUrl` isn't in the typehints but is considered stable.
        const realLocation = router.lastSuccessfulNavigation.targetBrowserUrl;
        router.navigateByUrl(realLocation, {
          skipLocationChange: true,
          onSameUrlNavigation: 'reload',
        });
      }
    });
  }
}
